import { getLastOrganisation } from "../../../../../lib/specialist";
import { useListingReviewCardContext } from "./ListingReviewCardProvider";
import { BodySmall } from "../../../../global/ui/typography";

export const ListingReviewCardOrganisation = () => {
  const { state } = useListingReviewCardContext();
  const lastOrganisation = getLastOrganisation(state.review.user);

  if (lastOrganisation) {
    return <BodySmall>{lastOrganisation?.name}</BodySmall>;
  }
};
